import initFaviconChanger from './modules/favicon-changer';


/**
 *
 */
window.addEventListener( 'DOMContentLoaded', () =>
{
	initFaviconChanger();
} );